
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subscriptions",
      function () {
        return require("private-next-pages/subscriptions/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subscriptions"])
      });
    }
  